import React, {
  useCallback,
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import styles from "../../../styles/myAccount/myDocuments.module.scss";
import { sortCompareDefault } from "../../../utility/utils/storeCompare";
import { MY_DOCUMENTS } from "./myDocumentConstatnts";
import InvoicesPopUp from "../../ui/InvoicesPopUp";
import serviceDetailsCss from "../../../styles/myAccount/serviceDetails.module.scss";

function TableStructure({
  labels,
  data,
  headers,
  id,
  heading,
  targetValue,
  linkText,
  textForHeading: headingText,
}) {
  const rowKeys = ["desc", "date", "link"];
  const modalRef = useRef(null);
  const modalInstanceRef = useRef(null); // Bootstrap 5 Modal instance if available
  const backdropRef = useRef(null);
  const classType = (() => {
    switch (headingText) {
      case MY_DOCUMENTS.SERVICE:
        return "view-service-ticket";
      case MY_DOCUMENTS.INVOICE:
        return "view-invoice view-invoice-my-documents";
      case MY_DOCUMENTS.WELCOME:
        return "view-letter-my-documents";
      case MY_DOCUMENTS.PREPAY:
        return "view-letter-my-documents";
    }
    return "";
  })();

  const [state, setState] = useState({
    sortBy: rowKeys[1],
    sortDesc: true,
    invoiceNum: "",
    popupData: {},
  });

  const handleSort = (value) => {
    var { sortDesc, sortBy } = state;
    if (value === sortBy) {
      sortDesc = !sortDesc;
    }
    setState((prev) => ({ ...prev, sortBy: value, sortDesc }));
  };

  const ensureModalInstance = useCallback(() => {
    if (typeof window === "undefined") return;
    const bootstrap = window.bootstrap;
    if (bootstrap?.Modal && modalRef.current && !modalInstanceRef.current) {
      modalInstanceRef.current = new bootstrap.Modal(modalRef.current, {
        backdrop: "static",
      });
    }
  }, []);

  const showModalFallback = useCallback(() => {
    if (!modalRef.current) return;
    const el = modalRef.current;
    el.classList.add("show");
    el.style.display = "block";
    el.removeAttribute("aria-hidden");
    el.setAttribute("aria-modal", "true");

    // Create backdrop
    const backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop fade show";
    document.body.appendChild(backdrop);
    backdropRef.current = backdrop;

    document.body.classList.add("modal-open");
  }, []);

  const hideModalFallback = useCallback(() => {
    if (!modalRef.current) return;
    const el = modalRef.current;
    el.classList.remove("show");
    el.style.display = "";
    el.setAttribute("aria-hidden", "true");
    el.removeAttribute("aria-modal");

    // Remove backdrop
    if (backdropRef.current && backdropRef.current.parentNode) {
      backdropRef.current.parentNode.removeChild(backdropRef.current);
      backdropRef.current = null;
    }
    document.body.classList.remove("modal-open");
  }, []);

  const handleClose = useCallback(
    (e) => {
      e.preventDefault();
      if (modalInstanceRef.current) {
        modalInstanceRef.current.hide();
      } else {
        hideModalFallback();
      }
    },
    [hideModalFallback]
  );

  const handlePopUp = (e, data) => {
    if (headingText === MY_DOCUMENTS.INVOICE) serviceModal(e, data);
  };


  const serviceModal = useCallback(
    (e, dataForPopup) => {
      e.preventDefault();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "account_action",
        category: "Account",
        action: "my documents",
        label: "view invoice",
        customer_id: id || {},
        error: { reason: "" },
      });

      setState((prev) => ({...prev, popupData : dataForPopup}));

      // Show using Bootstrap 5 if available, else fallback
      ensureModalInstance();
      if (modalInstanceRef.current) {
        modalInstanceRef.current.show();
      } else {
        showModalFallback();
      }
    },
    [ensureModalInstance, showModalFallback]
  );

  useEffect(() => {
    return () => {
      try {
        modalInstanceRef.current?.hide();
        modalInstanceRef.current?.dispose?.();
      } catch (_) {}
      if (backdropRef.current) {
        hideModalFallback();
      }
    };
  }, [hideModalFallback]);

  const { sortBy, sortDesc, popupData } = state;
  let sortedData = data.sort(sortCompareDefault(sortBy));
  let iconClass = "icon-chevron-down";

  if (!sortDesc) {
    sortedData = sortedData.reverse();
    iconClass = "icon-chevron-up";
  }

  return (
    <>
      <div
        id={id}
        aria-expanded="true"
        className={`collapse bg-white pb-md-16 pt-md-30 ${styles["tru-mma-main-service-box"]} w-100 show`}
      >
        {data !== null && (
          <div className="container-fluid gfs-16 g-text-underline">
            <div className="d-none d-md-flex row">
              {headers.map((header, i) => (
                <div
                  key={`th-${id}-${i}`}
                  className={`col-4 ${styles["column-header"]}`}
                  onClick={() => handleSort(rowKeys[i])}
                >
                  <span
                    className={styles["tg-tablestr-cur"]}
                    style={{ visibility: "visible" }}
                  >
                    {header}
                  </span>
                  <span
                    className={
                      sortBy === rowKeys[i]
                        ? `${styles[`icon-chevron`]} ${styles[iconClass]}`
                        : ""
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {data !== null && (
          <div
            className={`${styles["alternate-doc-bg"]} container-fluid gfs-20 gfs-md-16 gfw-4 gfw-md-300`}
            style={{ visibility: "visible" }}
          >
            {sortedData.map((row, i) => (
              <div key={`row-${id}-${i}`} className="row py-16 py-md-2">
                <div className="col-12 col-md-4">{row[rowKeys[0]]}</div>
                <div className="col-12 col-md-4">{row[rowKeys[1]]}</div>
                <div className="col-12 col-md-4">
                  <a
                    target={targetValue}
                    onClick={(e) => handlePopUp(e,row)}
                    href={row[rowKeys[2]]}
                    invoicenum={row.invoiceNumber}
                    className={classType}
                  >
                    {linkText}
                  </a>
                </div>
              </div>

            ))}
          </div>
        )}
        
        <InvoicesPopUp
          modalRef={modalRef}
          labels={labels}
          handleCloseModal={handleClose}
          data={popupData}
          serviceDetailsCss={serviceDetailsCss}
        /> 
      </div>
    </>
  );
}

export default TableStructure;
